"use client"

import { Canvas } from "@react-three/fiber"
import { OrbitControls, Environment, useGLTF, Float, ContactShadows } from "@react-three/drei"
import { Suspense } from "react"

function Model() {
  // Substitua o caminho abaixo pelo seu arquivo .glb
  const { scene } = useGLTF("/assets/3d/motherboarda.glb")
  
  return (
    <Float
      speed={2}
      rotationIntensity={0.5}
      floatIntensity={0.5}
    >
      <primitive 
        object={scene} 
        scale={2.5}
        position={[0, -0.5, 0]}
      />
    </Float>
  )
}

function LoadingFallback() {
  return (
    <mesh>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color="#22c55e" wireframe />
    </mesh>
  )
}

export function ModelViewer() {
  return (
    <div className="w-full h-[500px] lg:h-[600px]">
      <Canvas
        camera={{ position: [0, 0, 5], fov: 45 }}
        className="rounded-2xl"
      >
        <ambientLight intensity={0.5} />
        <directionalLight position={[10, 10, 5]} intensity={1} />
        <spotLight position={[-10, 10, -5]} intensity={0.5} />
        
        <Suspense fallback={<LoadingFallback />}>
          <Model />
          <Environment preset="city" />
        </Suspense>
        
        <ContactShadows
          position={[0, -1.5, 0]}
          opacity={0.4}
          scale={10}
          blur={2}
        />
        
        <OrbitControls
          enableZoom={false}
          enablePan={false}
          autoRotate
          autoRotateSpeed={2}
          minPolarAngle={Math.PI / 4}
          maxPolarAngle={Math.PI / 2}
        />
      </Canvas>
    </div>
  )
}
